import { Typography } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";

const MetaTagListItems = ({ formData, onEdit }) => {
  return (
    <div className="container">
      <div className="label"></div>
      <div>
        <div className="answer">
          <h4 className="quest-header">Meta Title</h4>
          <Typography> {formData?.metaTitle}</Typography>
          {/* <DeleteIcon style={{ cursor: "pointer" }}> </DeleteIcon> */}
          <EditIcon style={{ cursor: "pointer" }} onClick={onEdit} />
        </div>
        <div className="answer">
          <h4 className="quest-header">Meta Description</h4>
          <Typography>{formData?.metaDescription}</Typography>
        </div>

        <div className="answer">
          <h4 className="quest-header">Canonical URL</h4>
          <Typography>{formData?.canonicalUrl}</Typography>
        </div>

        <div className="answer">
          <h4 className="quest-header">SEO Content</h4>
          <div style={{ width: "100%", overflow: "hidden" }}>
            <Typography
              component="div"
              variant="body2"
              sx={{
                width: "100%",
                maxWidth: "100%",
                "& table": {
                  borderCollapse: "collapse",
                  width: "100%",
                  tableLayout: "auto",
                  "& td, & th": {
                    border: "1px solid #ccc",
                    padding: "8px",
                    maxWidth: "300px",
                    whiteSpace: "normal",
                    wordBreak: "break-word",
                    overflowWrap: "break-word",
                    wordWrap: "break-word",
                  },
                  "& th": {
                    backgroundColor: "#f5f5f5",
                    fontWeight: "bold",
                  },
                },
                "& p, & div, & span": {
                  whiteSpace: "normal",
                  wordBreak: "break-word",
                  overflowWrap: "break-word",
                },
                "& *": {
                  maxWidth: "100%",
                },
              }}
              dangerouslySetInnerHTML={{ __html: formData?.seoContent }}
            />
          </div>
        </div>
        <div
          style={{
            width: "100%",
            background: "gray",
            height: "1px",
            marginTop: "30px",
          }}
        ></div>
      </div>
    </div>
  );
};

export default MetaTagListItems;
